module.exports = __webpack_public_path__ + "static/media/Picture23.9c5cb263.png";